// src/redux/reducers/baselineAssessmentReducer.js
import {
  SET_BASELINE_ASSESSMENTS,
  CLEAR_BASELINE_ASSESSMENTS,
  SET_BASELINE_LOADING,
  SET_BASELINE_ERROR,
  SET_BASELINE_CURRENT_PROGRAM,
  // ✅ NEW
  SET_BASELINE_CONTEXT,
} from "../actions";

const initialState = {
  byProgram: {
    // [programName]: {
    //   written: { questions: [...] },
    //   verbal : { questions: [...] },
    //   lastUpdated: 1680000000000
    // }
  },
  // ✅ NEW: top-level programName for simple consumers
  programName: null,

  currentProgram: null,       // which programme the UI is showing (optional)
  loading: false,
  loadingLabel: "",
  error: null,

  // ✅ NEW: stash company/brand (+optional learnerId) so the page can resolve immediately after nav
  context: {
    company: "",
    collectionBrand: "",
    learnerId: "",
  },
};

export default function baselineAssessmentReducer(state = initialState, action) {
  switch (action.type) {
    case SET_BASELINE_LOADING: {
      const { loading, label = "" } = action.payload || {};
      return { ...state, loading: !!loading, loadingLabel: label };
    }

    case SET_BASELINE_ERROR:
      return { ...state, error: action.payload || null };

    case SET_BASELINE_CURRENT_PROGRAM:
      return { ...state, currentProgram: action.payload || null };

    // ✅ NEW: persist context values
    case SET_BASELINE_CONTEXT: {
      const { company, collectionBrand, learnerId, programName } = action.payload || {};
      return {
        ...state,
        context: {
          company:         company         ?? state.context.company,
          collectionBrand: collectionBrand ?? state.context.collectionBrand,
          learnerId:       learnerId       ?? state.context.learnerId,
        },
        // mirror programName at top-level for easy reads (optional but handy)
        programName: programName ?? state.programName,
        // optionally align currentProgram with programName if provided
        currentProgram: programName ?? state.currentProgram,
      };
    }

    case SET_BASELINE_ASSESSMENTS: {
      const { programName, written, verbal } = action.payload || {};
      if (!programName) return state;

      return {
        ...state,
        byProgram: {
          ...state.byProgram,
          [programName]: {
            written: written || state.byProgram[programName]?.written || null,
            verbal : verbal  || state.byProgram[programName]?.verbal  || null,
            lastUpdated: Date.now(),
          },
        },
        // keep a simple mirror for easy access
        programName,
        currentProgram: programName,
        loading: false,
        loadingLabel: "",
        error: null,
      };
    }

    case CLEAR_BASELINE_ASSESSMENTS: {
      const programName = action.payload;
      if (!programName) {
        // wipe everything
        return initialState;
      }
      if (!state.byProgram[programName]) return state;

      const next = { ...state.byProgram };
      delete next[programName];
      const nextCurrent =
        state.currentProgram === programName ? null : state.currentProgram;

      // if we just cleared the "mirror" program, unset programName as well
      const nextProgramName =
        state.programName === programName ? null : state.programName;

      return {
        ...state,
        byProgram: next,
        currentProgram: nextCurrent,
        programName: nextProgramName,
      };
    }

    default:
      return state;
  }
}

/* ───────────── Selectors (optional, handy) ───────────── */

export const selectBaselineSlice = (s) => s.baselineAssessment;

export const selectBaselineForProgram = (s, programName) =>
  s.baselineAssessment.byProgram[programName] || null;

export const selectBaselineWritten = (s, programName) =>
  s.baselineAssessment.byProgram[programName]?.written || null;

export const selectBaselineVerbal = (s, programName) =>
  s.baselineAssessment.byProgram[programName]?.verbal || null;

export const selectBaselineLoading = (s) => ({
  loading: s.baselineAssessment.loading,
  label  : s.baselineAssessment.loadingLabel,
});

export const selectBaselineError = (s) => s.baselineAssessment.error;

// ✅ NEW: easy selectors
export const selectBaselineContext = (s) => s.baselineAssessment.context;
export const selectBaselineProgramName = (s) => s.baselineAssessment.programName;
